import React from "react";

export const Description = ({ description, response }) => {
    return (
        <><p><u>{description}</u></p>
        <p className="response">{response}</p></>
    )
}